import { Injectable } from '@angular/core'

declare const Favico: any

@Injectable()
export class FaviconService {

  private favicon
  private counter = 0

  constructor() {
    this.favicon = new Favico({
      bgColor: '#ff0000',
      textColor: '#fff',
      animation: 'slide',
      position: 'up'
    })
  }

  increment() {
    if (this.counter < 100) {
      this.counter++
      this.favicon.badge(this.counter)
    }
  }

  decrement() {
    if (this.counter > 0) {
      this.counter--
      this.favicon.badge(this.counter)
    }
  }

  reset() {
    this.favicon.badge(0)
    this.counter = 0
  }

  set(num: number) {
    this.counter = num
    this.favicon.badge(num)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/favicon/favicon.service.ts